import { HttpQueryConfig } from '../../../core/model/HttpQueryConfig.model';

export const SlaMonitoredServicesHttpQuery: HttpQueryConfig = {
  GetSlaMonitoredServices: {
    key: 'GetSlaMonitoredServices',
    url: '/api/customers/{customerId}/sla-monitored-services',
    errors: {},
  },
  GetSlaMetricsMeasurement: {
    key: 'GetSlaMetricsMeasurement',
    url: '/api/customers/{customerId}/l3-services/{itemId}/classes-of-service/{cosId}/sla-metrics-measurements',
    errors: {}
  }
};
